import React, { useEffect , useContext } from 'react';
import {
  Marker,
  Popup,
  useMap
} from "react-leaflet";
import L from 'leaflet';
import { menu2icon } from './config';
import {Context} from "../../../store/reducer";

/**
 * 90_15: 共通_被爆樹木情報のマーカー
 *
 * 
 * @param spot
 * @param latitude
 * @param longitude
 * @param menu
 * @param draggable
 * @param option
 * @returns {JSX.Element|null}
 * @constructor
 */
const Component = ({spot, latitude, longitude, menu, draggable=false, option}) => {
  
  const { state } = useContext(Context);

  const icon = menu2icon[option.id]

  const iconUrl = new L.Icon({
    iconUrl: icon,
    iconRetinaUrl: icon,
    iconSize: [35, 35],
    iconAnchor: [17, 23],
    popupAnchor: [0, -50]
  });

  const map = useMap()
  const bounds = map.getBounds()
  const minlat = bounds._southWest.lat
  const maxlat = bounds._northEast.lat
  const minlng = bounds._southWest.lng
  const maxlng = bounds._northEast.lng

  const handleSpotData = (menu, spot) => {

    let ret = []
    
    // データセット情報の取得
    const dataset = state.data_for_90.data["vis_90_15"]

    if (dataset) {
      ret.push(<dl className='dl-list is-modal-spot'><dd><a href={dataset.url} target={"_blank"}>各種法令の規制情報_被爆樹木基本情報</a></dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>施設ID</dt><dd>{spot["施設ID"]}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>名称</dt><dd>{spot["名称"]}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>所在地</dt><dd>{spot["所在地"]}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>緯度</dt><dd>{spot["緯度"]}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>経度</dt><dd>{spot["経度"]}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>所有者等</dt><dd>{spot["所有者等"]}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>URL</dt><dd> { spot["URL"] && <a href={spot["URL"]} target={"_blank"}>{spot["URL"]}</a>}</dd></dl>)
    }

    return ret

  }

  if(latitude > minlat && latitude < maxlat && longitude > minlng && longitude < maxlng){

    return (
      <>
        <Marker
          position={[latitude, longitude]}
          icon={iconUrl}
        >
          <Popup autoPan={false}  minHeight={300} maxHeight={400} minWidth={500} closeOnClick>
            {
              handleSpotData(menu, spot)
            }
          </Popup>
        </Marker>

      </>
    );
  }else{
    return null
  }
}

export default Component;
